export { Badge } from "./component";
export type {
  BadgeProps,
  BadgeSize,
  BadgeStyleProps,
  BadgeVariant,
} from "./types";
